import { fmt } from "../../lib/format";
import { signedPct } from "../../lib/community";

export function GwLogo({ size = 22 }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
      <circle cx="32" cy="32" r="30" fill="#0F2A22" /><circle cx="32" cy="32" r="26.5" fill="none" stroke="#D9A94A" strokeWidth="1.2" />
      <path d="M42.5 19.5 A17 17 0 1 0 45.5 41" fill="none" stroke="#F6F2E8" strokeWidth="5" strokeLinecap="round" />
      <line x1="33" y1="35" x2="40" y2="35" stroke="#F6F2E8" strokeWidth="5" strokeLinecap="round" />
      <line x1="45.5" y1="21" x2="45.5" y2="47" stroke="#5BD48F" strokeWidth="2.2" strokeLinecap="round" />
      <rect x="41.5" y="27" width="8" height="13" rx="2" fill="#5BD48F" />
    </svg>
  );
}

const money = (v) => `₹${fmt(v)}`;

export function ShareCard({ card, showAmount, name }) {
  const win = card.kind === "win";
  const big = win ? (showAmount ? `+${money(card.pnl)}` : signedPct(card.pct)) : card.side;
  const sub = win ? (showAmount ? signedPct(card.pct) : "Return on trade") : "Trade placed";
  const cells = win
    ? [["ENTRY", money(card.entry)], ["EXIT", money(card.exit)], ["RESULT", signedPct(card.pct)]]
    : [["ENTRY", money(card.entry)], ["STOP LOSS", card.sl ? money(card.sl) : "—"], ["RISK", card.risk_pct != null ? `${card.risk_pct.toFixed(2)}%` : "—"]];
  return (
    <div className="gw-card" data-testid="share-card-preview">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center gw-serif"><GwLogo /><span>Greenwick</span></div>
        <span className="gw-badge" data-testid="share-card-status"><span className="gw-live" />{win ? "Profit booked" : "Live trade"}</span>
      </div>
      <div className="sym" data-testid="share-card-symbol">{card.symbol}<span className="side">{card.side}</span></div>
      <svg className="gw-sp hidden sm:block" viewBox="0 0 130 46"><polyline points="0,38 15,34 28,36 42,27 55,29 70,20 84,22 98,12 112,14 130,4" fill="none" stroke="#5BD48F" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
      <div className={`big ${win ? "gw-goldtext" : ""}`} data-testid="share-card-big">{big}</div>
      <div className="gw-mute text-[13px] mt-1">{sub}</div>
      <div className="grid">
        {cells.map(([k, v]) => <div key={k}><small>{k}</small><b style={k === "RESULT" ? { color: "var(--gw-green)" } : undefined}>{v}</b></div>)}
      </div>
      <div className="ft"><span data-testid="share-card-name">{name || "A Greenwick trader"}</span><span data-testid="share-card-sim-line">Simulated capital · Greenwick evaluation</span></div>
    </div>
  );
}
